import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import Appointmentneet from './appointmentneet';

class Page_header extends Component {

    render() {

        let HeaderTitle = this.props.headertitle;
        let publicUrl = process.env.PUBLIC_URL+'/'
        let Subheader = this.props.subheader ? this.props.subheader : HeaderTitle

        return (


	<div className="breadcrumb-area bg-overlay" style={{backgroundImage: 'url("'+publicUrl+'assets/img/website/background-miet.jpg")'}}>
	  <div className="container">
		<div className='row'> 
		<div className='col-md-8' style={{margin:'auto'}}>
	    <div className="breadcrumb-inner">
	      <div className="section-title mb-0 text-center">
	        <h1 className="page-title">{ HeaderTitle }</h1>
	      </div>
	    </div>
	  </div>
	  <div className='col-md-4'>
	  {/* <Appointmentneet /> */}
	  </div>

	  </div>
	  </div>
	</div>



        )
    }
}


export default Page_header